const styleSheet = new CSSStyleSheet({ media: 'screen' })
const css = (str) => str[0]

styleSheet.replace(css`
  html {
    font-size: 1vw;
  }
`)

export default styleSheet
